import PropTypes from 'prop-types';
import { CircleOff } from 'lucide-react';

const EmptyState = ({ title, description, action }) => (
  <div className="flex min-h-[220px] flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50/70 p-8 text-center">
    <span className="mb-4 rounded-full bg-white p-3 text-slate-400 shadow-sm"><CircleOff className="h-6 w-6" /></span>
    <h3 className="text-base font-bold text-slate-900">{title}</h3>
    <p className="mt-1 max-w-md text-sm text-slate-500">{description}</p>
    {action && <div className="mt-5">{action}</div>}
  </div>
);

EmptyState.propTypes = { title: PropTypes.string.isRequired, description: PropTypes.string, action: PropTypes.node };
export default EmptyState;
